import type { RulesetsGlobalContext } from '@library/types/rulesets';
import { createContext } from 'react';

export const RulesetsContext = createContext<RulesetsGlobalContext>({
  setExpandAllPhantoms: () => {},
  selectedQualifiedPath: '',
  setSelectedQualifiedPath: () => {},
  currentRuleset: undefined,
  expandAllPhantoms: true,
  gameOpsGlobalRuleset: undefined,
  gameModesGlobalRulesets: undefined,
  modifiedFields: {},
  handleDiscardChanges: () => {},
  handleUpdateRulesetField: () => {},
  handleSubmitUpdate: () => Promise.resolve(),
  handleResetRuleset: () => {},
  isSubmitSuccess: false,
  isSubmitError: false,
  isSubmitLoading: false,
  resetUpdate: () => {},
  resetCreate: () => {},
  isRulesetFetching: false,
  isGameOpsLoading: false,
  isGameOpsFetching: false,
  isGameModesLoading: false,
  isGameModesFetching: false,
  allowedRules: undefined,
  matchedAllowedRules: new Set(),
  matchedAllowedRuleTypes: {},
  handleOpenPreviewModal: () => {},
  handleClosePreviewModal: () => {},
  isPreviewModalOpen: false,
  handlePreviewChanges: () => Promise.resolve(),
  isPreviewLoading: false,
  previewData: null,
  handleResetPreview: () => {},
  customRuleset: undefined,
  isFetchingCustomRulesetRuleset: false
});
